<template>
  <div class="q-ma-xl">
    <q-card class="success text-center q-pa-md" flat bordered>
      <q-card-section>
        <div class="text-h5 q-pb-md">Thank you for subscribing!</div>
        <q-banner class="text-weight-medium">
          {{ message }}
        </q-banner>
        <q-linear-progress
          :value="ready ? 1.0 : seconds / 45"
          :color="ready ? 'green' : 'primary'"
          :animation-speed="2000"
          class="q-mt-md"
        />
      </q-card-section>
    </q-card>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'

export default {
  name: 'SuccessView',
  components: {},
  data() {
    return {
      ready: false,
      seconds: 0,
      messages: [
        'Receiving the last few bits of information to set up your account.',
        'Setting up your new account. This should only take a few moments.',
        'Analyzing rent and availability data from over 5 million multifamily properties across the U.S.',
        'Assessing real estate quality and condition from listing photos.',
        'Analyzing property characteristics and amenities.',
        'Calculating the dollar value of concessions from specials text.',
        'Computing average operating expenses by property size and market.',
        'Activating rent comp recommendation system.',
        "It is taking a bit longer than usual, but we got you covered. Please stay on this page, and we will redirect you as soon as it's all ready."
      ]
    }
  },
  computed: {
    message(): string {
      if (this.ready) {
        return 'All done! You will be redirected shortly.'
      }

      const idx = Math.min(Math.floor(this.seconds / 4), this.messages.length - 1)
      return this.messages[idx]
    }
  },
  mounted() {
    this.seconds = 2
    const interval = setInterval(() => {
      this.seconds += 2
      this.$auth0.getAccessTokenSilently({ cacheMode: 'off' })
      if (useStripeStore().hasPropertyReports) {
        this.ready = true
        clearInterval(interval)
        setTimeout(() => {
          location.href = window.origin + (this.$route.query.path || '')
        }, 1000)
      }
    }, 2000)
  }
}
</script>
<style scoped>
.success {
  max-width: 608px;
  margin: auto;
}
</style>
